import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import api from '@board/api'
import { cache } from '@/modules/@appbase/util'

@Component({
})
export default class RecommendContainer extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    recommends: article.RecommendSet[] = []
    photos: any[] = []
    avatar = {
        url: '',
        loading: false,
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    getRecommentList(articleId: number) {
        api.article.getRecommendList(articleId).then(res => {
            this.recommends = res
            this.getPersonPhotos(this.recommends)
        })
    }

    getPersonImage(personCode: string) {
        const personImage = this.photos.filter((photo: any) => 
            photo.personCode === personCode
        )

        console.log('personImage', personImage)
        return personImage[0].photoPath;
    }

    getPersonPhotos(recommends: article.RecommendSet[]) {
        let codes: string[] = [];
        this.recommends.map((r: article.RecommendSet) => {
            codes.push(r.userCode)
        });
        this.avatar.loading = true;
        cache.avatar.getByCodes(codes).then((res: any) => {
            this.avatar.loading = false;
            this.photos = res;
        });
    }

    error(e: Event) {
        var elem = e.srcElement as HTMLImageElement;
        elem.src = '/cm/gres/v1/img/ghost_loading.png';
    }

    errorGhost(e: Event) {
        var elem = e.srcElement as HTMLImageElement;
        elem.src = '/cm/gres/faux/images/ghost.png';
    }

    @Watch('$route.query.articleId')
    onChangedId(articleId: string) {
        this.getRecommentList(Number(articleId))
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        const articleId = this.$route.query.articleId as string
        this.getRecommentList(Number(articleId))
    }
}
